export const betFaktors = {
    over: {
      factor: 2,
      title: "Over (Üst)",
      details: "Maçta toplam gol sayısı 2'den fazla olacağına dair bahis."
    },
    under: {
      factor: 2,
      title: "Under (Alt)",
      details: "Maçta toplam gol sayısı 3'ten az olacağına dair bahis."
    },
    totalGoal: {
      factor: 3,
      title: "Total Goals (Toplam Gol)",
      details: "Maçta atılacak toplam gol sayısını tahmin etmeye yönelik bahis."
    }
  };
  